export class DummyFilter {
    constructor() {
        this.model = null;
    }
    getGui() {
        const div = document.createElement('div');
        div.style.display = 'none';
        return div;
    }
    setModel(model) {
        this.model = model;
    }
    getModel() {
        return this.model;
    }
    isFilterActive() {
        return this.model !== null && this.model !== undefined;
    }
    doesFilterPass() {
        return true;
    }
    getModelAsString() {
        return '';
    }
    destroy() {
        this.model = null;
    }
}
